import { ReactComponent as FavouriteSolid } from "../../../assets/icons/fav-solid.svg";

type PropType = {
  onToggle: (data: any) => void;
  isFav: boolean;
};

const FavouriteButton = ({ onToggle, isFav }: PropType) => {
  return (
    <div>
      <FavouriteSolid
        onClick={onToggle}
        className={`${isFav ? "fill-primary" : "fill-none"}`}
      />
      {/* <img
        src={FavouriteSolid}
        alt=""
        className="cursor-pointer fill-red-400"
        onClick={onToggle}
      /> */}
    </div>
  );
};

export default FavouriteButton;
